import generateUtilityClass from '../generateUtilityClass';
export default function generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
  const result = {};
  slots.forEach(slot => {
    result[slot] = generateUtilityClass(componentName, slot, globalStatePrefix);
  });
  return result;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/utils/generateUtilityClasses/generateUtilityClasses.js
// module id = 1959
// module chunks = 0